import {
  Button,
  CircularProgress,
  TextField,
} from '@mui/material'
import Grid from '@mui/material/Grid2'
import SearchIcon from '@mui/icons-material/Search'
import CleaningServicesIcon from '@mui/icons-material/CleaningServices'
import React, { useEffect, useState } from 'react'
import { State, Status } from '../../hooks/useFetchState'
import { ReturnWorkOrderResponse } from './types'
import { getOrderDevolution } from './api'
import { searchFieldOptions } from './config'
import { AxiosResponse } from 'axios'
import { GenericDLL } from '../Almacen/UI/GenericDLL'
import { useTypeAsnIncome } from '../../hooks'
import { eTypeAsnIncome } from '../../enums/eTypeAsnIncome'

export interface SearchOrderProps {
  handleSearchOrders: (apiCall: Promise<AxiosResponse<any>>) => Promise<any>
  handleSelectedOT: (workOrderId: number, orderId?: number) => void
  state: State<ReturnWorkOrderResponse[]>
  handleStep: React.Dispatch<React.SetStateAction<number>>
  handleSnackbar: (msg: string | undefined, status: boolean) => void
  setIdle: () => void
  selectedTypeAsnIncome: number
  setSelectedTypeAsnIncome: React.Dispatch<React.SetStateAction<number>>
  setSelectedWarehouseId: React.Dispatch<React.SetStateAction<number>>
  setNewPreInbound: React.Dispatch<React.SetStateAction<boolean>>
  setSelectedOrderId: React.Dispatch<React.SetStateAction<number>>
}

export const SearchOrder: React.FC<SearchOrderProps> = ({
  handleSearchOrders,
  handleSelectedOT,
  state,
  handleStep,
  handleSnackbar,
  setIdle,
  selectedTypeAsnIncome,
  setSelectedTypeAsnIncome,
  setNewPreInbound,
  setSelectedOrderId,
  setSelectedWarehouseId
}) => {
  const {
    getTypeAsnIncome,
    typeAsnIncomeState: { typeAsnIncome }
  } = useTypeAsnIncome()

  const [selectedSearchField, setSelectedSearchField] = useState<string>('')
  const [selectedSearchValue, setSearchValue] = useState('')

  const catchError = () =>
    handleSnackbar(
      `No existen coincidencias para ${
        selectedSearchField === 'workOrderId' ? 'OT' : 'pedido'
      } ${selectedSearchValue}`,
      false
    )

  const getOrderForReturn = () => {
    setIdle()
    if (selectedSearchField !== '') {
      handleSearchOrders(
        getOrderDevolution(selectedSearchField, selectedSearchValue)
      )
        .then((response: ReturnWorkOrderResponse[]) => {
          if (selectedSearchField === 'workOrderId') {
            handleSelectedOT(response[0].workOrderId)
            setSelectedOrderId(response[0].orderId)
            setSelectedWarehouseId(response[0].warehouseId)
            handleStep(3)
          } else if (selectedSearchField === 'externalOrderId') {
            // si existe una sola orden de trabajo
            if (response.length === 1) {
              handleSelectedOT(response[0].workOrderId, response[0].orderId)
              setSelectedOrderId(response[0].orderId)
              setSelectedWarehouseId(response[0].warehouseId)
              handleStep(3)
            } else {
              // si existen muchas ordenes de trabajo
              handleStep(2)
            }
          }

          setNewPreInbound(true)
        })
        .catch(catchError)
    }
  }

  const handleInputChangeTypeAsnIncome = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSelectedTypeAsnIncome(Number(event.target.value))
  }

  const handleInputChangeBy = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSelectedSearchField(event.target.value)
  }

  const handleCleanAllData = () => {
    setSelectedTypeAsnIncome(-1)
    setSearchValue('')
    setSelectedSearchField('')
  }

  useEffect(() => {
    if (typeAsnIncome?.length === 0) {
      getTypeAsnIncome()
    }
  }, [])

  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 2, md: 3 }} style={{ textAlign: 'left' }}>
        <GenericDLL
          fullWidth
          initialValues={typeAsnIncome || []}
          onChange={handleInputChangeTypeAsnIncome}
          label='Tipo de ingreso'
          title='Tipo de ingreso'
          name='name'
          valueKey={'typeAsnIncomeId'}
          value={selectedTypeAsnIncome}
          variant='outlined'
          excludedOptions={[
            eTypeAsnIncome.Fulfillment,
            eTypeAsnIncome.Restocking
          ]}
        />
      </Grid>
      <Grid size={{ xs: 2, md: 2 }} style={{ textAlign: 'left' }}>
        <GenericDLL
          fullWidth
          initialValues={searchFieldOptions || []}
          onChange={handleInputChangeBy}
          label='Buscar Por'
          title=''
          name='name'
          valueKey={'value'}
          value={selectedSearchField}
          variant='outlined'
        />
      </Grid>
      <Grid size={{ xs: 10, md: 3 }}>
        <TextField
          name='searchValue'
          value={selectedSearchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          variant='outlined'
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 10, md: 3 }} sx={{ display: 'flex', gap: 1, ml: 'auto' }}>
        <Button
          disabled={
            selectedSearchField === '' ||
            selectedTypeAsnIncome === -1 ||
            selectedSearchValue === ''
          }
          variant='contained'
          color='primary'
          onClick={getOrderForReturn}
          size='large'
          sx={{ px: 2, py: 1.5, borderRadius: '12px' }}
          startIcon={
            state.status === Status.Loading ? (
              <CircularProgress size='small' />
            ) : (
              <SearchIcon />
            )
          }
        >
          Buscar
        </Button>
        <Button
          variant='outlined'
          color='primary'
          onClick={handleCleanAllData}
          size='large'
          sx={{ px: 2, py: 1.5, borderRadius: '12px' }}
          startIcon={<CleaningServicesIcon />}
        >
          Limpiar
        </Button>
      </Grid>
    </Grid>
  )
}
